angular.module('Itao.IndicatorMap').directive('lineChart', function (d3, mapConfig) {
  'use strict';

  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  //var color = function () {
  var colorset = d3.hyperion.indicatorColors;
  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var avgKey = mapConfig.avgKey;
  var avgName = mapConfig.avgName;
  var hideLegendScale = [];
  var colorDistrictMapping;

  /**
   * combines data of given layer and indicators
   * define colors using given colorset
   * data combines for single layer to display lines of each district
   *
   * @param layer
   * @param setIndicators
   * @param disabledDistrictKeys
   * @param disabledListIndex
   * @param colorset
   * @returns {{data: {name, key}[], yearsWithData: *[], noDataDistricts: *[]}}
   */
  var combineData = function (layer, setIndicators, disabledDistrictKeys, disabledListIndex, colorset) {
    var indicatorsWithoutLists = setIndicators;

    /**
     * filter out districts if disabledDistrictKeys is set
     * @type {string[]}
     */
    var filteredDistricts = Object.keys(layer.districts).filter(function (districtUid) {
      return disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1;
    });

    var data, yearsWithDataArray = [], noDataDistricts = [];
    var valueCheck = indicatorsWithoutLists.map(function () {
      return 0;
    });

    /**
     * map through districts and combines with indicatorData which are not added to indicator-type-lists
     * @type {{name, key}[]}
     */
    data = filteredDistricts.map(function (districtUid, distIdx) {
      var valueArray = indicatorsWithoutLists.map(function (indicator, index) {
        var indicatorName = indicator.name;
        var value;

        /**
         * adds value from layer
         */
        if (layer[districtUid] && layer[districtUid].hasOwnProperty(indicator.uid) && layer[districtUid][indicator.uid] !== null) {
          value = layer[districtUid][indicator.uid];
        } else {
          value = null;
          valueCheck[index]++;
        }

        /**
         * check if value is set and save to control-array
         */
        if (value !== null && yearsWithDataArray.indexOf(indicatorName) === -1) {
          yearsWithDataArray.push(indicatorName);
        }

        return {
          value: value,
          key: layer.districts[districtUid].key,
          id: layer.districts[districtUid].key,
          unit: indicator.unit,
          prefix: indicator.prefix,
          districtUid: districtUid,
          year: indicatorName,
          name: layer.districts[districtUid].name
        };
      }).filter(function (valueItem) {
        return !!valueItem.value;
      });

      /**
       * defines district-object
       * @type {{name, key, color, lastYear, lastValue, data, label}}
       */
      var districtObject = {
        key: layer.districts[districtUid].key,
        name: layer.districts[districtUid].name
      };

      /**
       * adds properties to districtObject
       */
      if (valueArray.length) {
        districtObject.color = colorDistrictMapping[districtObject.key] ? colorDistrictMapping[districtObject.key] : colorset[distIdx % colorset.length];
        districtObject.lastYear = valueArray[valueArray.length - 1].year;
        districtObject.lastValue = valueArray[valueArray.length - 1].value;
        districtObject.data = valueArray;
        districtObject.label = {keys: [], y: []};
      }

      return districtObject;
    }).filter(function (district) {
      var hasData = district.data && district.data.length > 0;
      if (!hasData) {
        noDataDistricts.push(district.key);
      }
      return hasData;
    });

    return {data: data, yearsWithData: yearsWithDataArray, noDataDistricts: noDataDistricts};
  };

  /**
   * combines data of given layers and indicators
   * define colors using given colorset
   * data combines for multiple layers to display lines of each indicator for one district
   *
   * @param layers
   * @param indicatorSet
   * @param disabledDataLayers
   * @param districtKey
   * @param colors
   * @param years
   * @returns {{data: *[], yearsWithData: *[], noDataDistricts: *[]}}
   */
  var combineYearlyData = function (layers, indicatorSet, disabledDataLayers, districtKey, colors, years) {
    var data = [], yearsWithDataArray = [], noDataDistricts = [], colorIdx = 0;

    /**
     * loop through indicators and set value-array for each year
     */
    indicatorSet.indicators.sort(function (a, b) {
      return a.sorting - b.sorting;
    });
    indicatorSet.indicators.forEach(function (indicator, index) {

      /**
       * ignore list-entries from legends
       * lists are not displayed in charts
       */
      if (indicator.list && index === 0 || (indicatorSet.indicators[index - 1] && indicatorSet.indicators[index - 1].list && indicatorSet.indicators[index - 1].list !== indicator.list)) {
        colorIdx++;
      }

      /**
       * write value to array
       */
      var valueArray = years.map(function (year) {
        var layer = layers[year],
          districtUid,
          value;

        /** get district from layer by district-key */
        for (var iUid in layer.districts) {
          if (layer.districts[iUid].key === districtKey) {
            districtUid = iUid;
            break;
          }
        }

        /**
         * sets value from layer by district and indicator
         */
        if (districtUid && layer[districtUid] && layer[districtUid].hasOwnProperty(indicator.uid) && layer[districtUid][indicator.uid] !== null) {
          value = layer[districtUid][indicator.uid];
        } else {
          value = null;
        }

        /**
         * check if value is set and save to control-array
         */
        if (value !== null && yearsWithDataArray.indexOf(year) === -1) {
          yearsWithDataArray.push(year);
        }

        return {
          value: value,
          key: colorIdx,
          id: indicator.uid,
          unit: indicator.unit,
          prefix: indicator.prefix,
          districtUid: indicator.uid,
          year: year,
          name: indicator.name
        };
      }).filter(function (valueItem) {
        return !!valueItem.value;
      });

      /**
       * defines lineObject
       * @type {{name, key, color, lineIndex, lastYear, lastValue, data, label}}
       */
      var lineObject = {
        key: colorIdx,
        name: indicator.name
      };

      /**
       * adds lineObjectProperties if valueArray has data
       */
      if (valueArray.length) {
        lineObject.color = colorset[colorIdx];
        lineObject.lineIndex = colorIdx; // uses color-index for to let out list-entries of legend
        lineObject.lastYear = valueArray[valueArray.length - 1].year;
        lineObject.lastValue = valueArray[valueArray.length - 1].value;
        lineObject.data = valueArray;
        lineObject.label = {keys: [], y: []};
      }

      colorIdx++;
      data.push(lineObject);
    });

    return {data: data, yearsWithData: yearsWithDataArray, noDataDistricts: noDataDistricts};
  };

  /**
   * defines lineChart-function to render visualization using d3
   * @returns {chart}
   */
  var lineChart = function () {
    var indicator = {},
      margin = {top: 40, right: 10, bottom: 40, left: 50},
      duration = 400,
      tip,
      redLines = null,
      labelMargin = 15,
      svgHeight = 200,
      focusDistrict = null,
      decimals,
      maxAxisValue,
      years;

    var chart = function (selection) {
      selection.each(function (data) {
        var minValue = 0,
          maxValue = 100,
          maxDomainValue,
          unit = indicator.defaultIndicator.unit,
          labelDigits = Math.max(germanNumberFormat(',')(Math.round(maxValue)).length, germanNumberFormat(',')(Math.round(minValue)).length);

        /**
         * defines chart-margins
         * @type {number}
         */
        margin.left = 20 + 10 * labelDigits;

        var container = d3.select(this).datum([data]).classed('line-chart', true),
          svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        /**
         * define chart-dimensions
         * @type {number}
         */
        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom,
          value;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        /**
         * defines d3-tip for mouse-over tooltips
         */
        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d) {
            if (!decimals) {
              decimals = d.unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            if (d.unit) {
              value = germanNumberFormat(',.' + decimals + 'f')(d.value) + d.unit;
            } else {
              value = germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border"><b>' + d.name + '</b><br/>' + '<span>' + d.year + ':</span> <span>' + value + '</span>';
          });

        /**
         * select svg from container and adds data-array
         */
        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio


        svgEnter.append('text')
          .attr('class', 'axis-unit-label')
          .attr('text-anchor', 'end')
          .attr('transform', 'translate(' + (margin.left - 7) + ', 10)');

        svg.select('.axis-unit-label')
          .text(unit === '%' ? 'in %' : '');

        /**
         * set viewBox of the svg
         */
        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth);

        /**
         * defines tickCount by svgHeight
         */
        var tickCount = Math.min(svgHeight / 40, 10);

        /**
         * defines main-margin-group and adds data-array
         */
        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        /**
         * check for max-axis-value to define scale of y-axis
         */
        if (maxAxisValue) {
          maxDomainValue = maxAxisValue;
        } else if (mapConfig.axisMaxValue != null) {
          maxDomainValue = mapConfig.axisMaxValue;
        } else {
          maxDomainValue = maxValue;
        }

        /**
         * defines d3-x-scale
         */
        var x = d3.scale.ordinal()
          .rangePoints([0, width - labelMargin])
          .domain(years);

        /**
         * defines d3-y-scale using linear-function
         * sets domain-value-array by min and max value
         */
        var y = d3.scale.linear()
          .range([height, 0])
          .domain([minValue, maxDomainValue])
          .nice();

        /**
         * defines d3-xAxis
         */
        var xAxis = d3.svg.axis()
          .scale(x)
          .orient('bottom')
          .tickValues(years);

        /**
         * definex d3-yAxis
         */
        var yAxis = d3.svg.axis()
          .scale(y)
          .orient('left')
          .ticks(tickCount)
          .tickFormat(germanNumberFormat(decimals ? ',.' + decimals + 'f' : ','));

        /**
         * adds x-axis to main-margin-group
         */
        gEnter.append('g')
          .classed('x axis', true)
          .attr('transform', 'translate(0,' + height + ')');

        /**
         * adds y-axis to main-margin-group
         */
        gEnter.append('g')
          .classed('y axis', true)
          .attr('y', height);

        if (angular.isArray(data) && data.length > 0) {
          /**update x axis by given data */
          g.select('.x.axis')
            .transition().duration(duration)
            .attr('transform', 'translate(0,' + height + ')')
            .call(xAxis);

          /** update y axis by given data */
          g.select('.y.axis')
            .transition().duration(duration)
            .attr('y', height)
            .call(yAxis);

          /**
           * scale by year-property
           * for single layer-visualization the year-property is used by district-keys
           */
          var x0 = d3.scale.ordinal()
            .rangeRoundBands([0, width - labelMargin], 0.3)
            .domain(data.map(accessor('year')));

          /**
           * adds grid-lines by d3.hyperion-service
           */
          g.call(d3.hyperion.addHorizontalGridLines(y, width - labelMargin, 0, tickCount, duration));
          g.call(d3.hyperion.addHorizontalHighlightArea(redLines, y, x0, width - labelMargin, duration));

          /**
           * defines line-generator by year and value-accessor
           */
          var lineGen = d3.svg.line()
            .x(compose(x, accessor('year')))
            .y(compose(y, accessor('value')));

          /**
           * defines lines
           */
          var lines = g.selectAll('.line')
            .data(data, accessor('key'));

          /**
           * enter lines and adds colors and stroke-width
           */
          lines.enter().append('path')
            .style('stroke', accessor('color'))
            .style('stroke-width', 2.5)
            .attr('class', function (d) {
              return focusDistrict === d.key || focusDistrict === d.lineIndex ? 'line line-focus' : 'line';
            });

          /**
           * draw lines
           */
          lines.transition().duration(duration)
            .style('fill', 'none')
            .attr('d', function (d) {
              return lineGen(d.data);
            })
            .attr('class', function (d) {
              return 'line focus-line_' + d.key;
            });

          /**
           * removes unused lines
           */
          lines.exit().remove();

          /**
           * create dots selection
           */
          var dotgroup = g.selectAll('.dotgroup')
            .data(data, accessor('key'));

          /** add new dots */
          dotgroup.enter()
            .append('g')
            .attr('fill', accessor('color'))
            .classed('dotgroup', true);

          /**
           * defines dots and adds data
           */
          var dots = dotgroup.selectAll('.dot')
            .data(function (d) {
              return d.data;
            });

          /** updates dots position and css-class */
          dots.enter()
            .append('circle')
            .classed('dot', true);

          dots.attr('class', function (d) {
            return 'dot focus-line_' + d.key + ' key-' + d.year + '-' + d.districtUid/* + focusClass*/;
          })
            .transition().duration(duration)
            .attr('r', 4)
            .attr('cx', compose(x, accessor('year')))
            .attr('cy', compose(y, accessor('value')));

          /**
           * binds d3-tips to dots
           */
          if (dots.size() > 0) {
            dots.call(tip);
          } else {
            tip.destroy();
          }

          var labelYs = [],
            labelOffset = 5;
          data.forEach(function (item) {
            var labelY = y(accessor('lastValue')(item));
            var self = labelY;
            var overlap = false;
            var a = {top: self - labelOffset, bottom: self + labelOffset};
            for (var j = 0; j < labelYs.length; j++) {
              var that = labelYs[j];
              if (self !== that) {
                var b = {top: that - labelOffset, bottom: that + labelOffset};
                if (!(
                  b.top > a.bottom ||
                  b.bottom < a.top
                )) {
                  data[j].label.keys.push(item.key);
                  data[j].label.y.push(labelY);
                  overlap = true;
                  break;
                }
              }
            }
            if (!overlap) {
              item.label.keys.push(item.key);
              item.label.y.push(labelY);
            }
            labelYs.push(labelY);
          });

          /**
           * voronoi calculator
           * extends mouse-over for dots using d3-voronoi-function
           * voronoi used for showing the tooltip of the point closest to the cursor
           */
          var voronoi = d3.geom.voronoi()
            .x(compose(x, accessor('year')))
            .y(compose(y, accessor('value')))
            .clipExtent([[0, 0], [width, height]]);

          var voronoiData = data.reduce(function (prev, current) {
            return prev.concat(current.data);
          }, []);

          var voronoiPolygons = g.selectAll('.voronoi')
            .data(voronoi(voronoiData));

          /**
           * add voronoi pahts and register mouseEvents for tooltips
           */
          voronoiPolygons.enter()
            .append('path')
            .style('fill', 'none')
            .style('pointer-events', 'all')
            .attr('class', 'voronoi')
            .on('mouseover', function (d) {
              var dot = g.select('.key-' + d.point.year + '-' + d.point.districtUid);
              tip.show(d.point, dot.node());
            })
            .on('mouseout', function (d) {
              tip.hide(d.point);
            });

          /**
           * updates voronoi paths
           */
          voronoiPolygons
            .attr('d', function (d) {
              if (d == null) {
                return '';
              }
              return 'M' + d.join('L') + 'Z';
            });

          g.selectAll('line.highlightLine').remove();
          g.call(d3.hyperion.addHorizontalHighlightLines(redLines, y, width - labelMargin, duration));

          /**
           * deletes unused voronoi paths
           */
          voronoiPolygons.exit().remove();
          dots.exit().remove();
          dotgroup.exit().remove();
        } else {
          /**
           * remove chart if no data is given
           */
          if (angular.isDefined(tip)) {
            tip.destroy();
          }
          g.selectAll('.dotgroup').remove();
          g.selectAll('.voronoi').remove();
          g.selectAll('.dot').remove();
          g.selectAll('.label').remove();
          g.selectAll('.line').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Object} [newIndicator] set of new indicators
     * @returns {*}
     */
    chart.indicator = function (newIndicator) {
      if (!arguments.length) {
        return indicator;
      } else {
        indicator = newIndicator;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newFocusDistrict] height of the diagram
     * @returns {*}
     */
    chart.focusDistrict = function (newFocusDistrict) {
      if (!arguments.length) {
        return focusDistrict;
      } else {
        focusDistrict = newFocusDistrict;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    /**
     * getter/setter for years
     * @param {Array} [newYears] set of new years
     * @returns {*}
     */
    chart.years = function (newYears) {
      if (!arguments.length) {
        return years;
      } else {
        years = newYears;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    return element.closest('.grid-stack-item-content-lineChart').height() - 25;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'lineChart.html',
    scope: {
      indicators: '=',
      indicatorSets: '=',
      colorsets: '=',
      selectedDistricts: '=',
      selectedDistrictKey: '=',
      noDataDistricts: '=',
      disabledDataLayers: '=',
      yearlyMode: '=',
      layers: '=',
      layer: '=',
      disabledDistrictKeys: '=',
      disabledListIndex: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '=',
      mouseOverFeature: '='
    },
    link: function (scope, element) {
      var lineChartFunction = lineChart();
      scope.config.indicatorToShow = scope.config.indicatorToShow || '';
      scope.config.disabledDistricts = scope.config.disabledDistricts || [];
      scope.config.fullscreen = scope.config.fullscreen || false;

      var data, height;
      /**
       * removes old chart
       */
      var removeChart = function () {
        scope.config.selectedIndicatorSet = null;
        d3.select(element[0]).select('svg').remove();
      };

      /**
       * defines rerender-function
       * rerender is always called if watched properties changed
       */
      var rerender = function () {
        scope.selectedIndicatorSet = undefined;
        var years = Object.keys(scope.layers);
        var filteredYears = [];
        var redLines,
          indicators = scope.indicators.filter(function (indicator) {
            return indicator.hasShapeData;
          });

        //var districtsKeyUidMapping = {};
        //angular.forEach(scope.layer.districts, function (district) {
        //  districtsKeyUidMapping[district.key] = district.uid;
        //});

        /**
         * calculates chartHeight
         * @type {number}
         */
        height = calculateChartHeight(element);

        var decimals,
          maxAxisValue;
        if (angular.isArray(indicators) && indicators.length > 0 /*&& indicators[0].isDefault*/) {

          /**
           * first selected indicator belongs to an indicatorSet
           * @type {unknown[]}
           */
          var selectedSets = scope.indicatorSets.filter(function (set) {
            return set.uid === indicators[0].type;
          });

          if (selectedSets.length > 0) {
            /**
             * set selectedIndicatorSet
             * @type {*}
             */
            scope.selectedIndicatorSet = selectedSets[0];
            scope.config.selectedIndicatorSet = selectedSets[0].uid;

            /**
             * get defaultIndicatorUid from selectedIndicatorSet
             * needed for legend
             * @type {number}
             */
            var defaultIndicatorUid = (+scope.selectedIndicatorSet.defaultIndicator.uid);

            /**
             * get defaultColorSet from d3.hyperion-service
             * @type {string[]}
             */
            colorset = d3.hyperion.indicatorColors;
            var legend = null;
            colorDistrictMapping = {};

            /**
             * get legend by defaultIndicatorUid
             */
            if (scope.layer.legend != null && scope.layer.legend.hasOwnProperty(defaultIndicatorUid) && scope.layer.legend[defaultIndicatorUid].chart != null) {
              legend = scope.layer.legend[defaultIndicatorUid];
              colorset = scope.colorsets.filter(function (colorset) {
                return (+colorset.uid) === (+legend.chart.colorSet);
              })[0].colors.map(function (color, idx) {
                colorDistrictMapping[legend.chart.scales[idx].district] = color.color;
                return color.color;
              });

              /**
               * get decimals from legend
               */
              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              /**
               * get maxAxisValue from legend
               */
              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              /**
               * get redLines from legend
               */
              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines; // ToDo: Where to use redLines
              }
            }

            /**
             * disable scales by hideLegendScale-Array
             */
            if (legend && legend.chart && legend.chart.scales) {
              legend.chart.scales.forEach(function (scale, idx) {
                scale.disabled = hideLegendScale.indexOf(idx) > -1;
              });
            }

            /**
             * display multiple years and indicator-set-children focused on one district if yearlyMode mode is active
             * else
             * display multiple district as lines focused on one year and indicator
             */
            if (scope.yearlyMode) {
              scope.yearsToHide = mapConfig.yearsToHide ? mapConfig.yearsToHide : [];
              filteredYears = years
                .filter(function (year) {
                  return scope.layers[year].indicators.indexOf(indicators[0].uid) !== -1 && scope.disabledDataLayers.indexOf(year) === -1;
                })
                .filter(function (year) {
                  return scope.yearsToHide.indexOf(year) === -1;
                })
                .map(function (year) {
                  return +year;
                });

              /**
               * combines data for multiple years
               * @type {{data: *[], yearsWithData: *[], noDataDistricts: *[]}}
               */
              data = combineYearlyData(scope.layers, scope.selectedIndicatorSet, scope.disabledDataLayers, scope.selectedDistrictKey, colorset.colors, filteredYears);
            } else {
              var setIndicators = scope.selectedIndicatorSet.indicators.filter(function (indicator, idx) {
                return indicator.list === false;
              }).sort(function (a, b) {
                return a.listIndex - b.listIndex;
              });

              /**
               * combines data for single year
               * @type {{data: {name, key}[], yearsWithData: *[], noDataDistricts: *[]}}
               */
              data = combineData(scope.layer, setIndicators, scope.disabledDistrictKeys, scope.disabledListIndex, colorset);

              /**
               * add no data districts to index
               */
              data.noDataDistricts.forEach(function (districtKey) {
                if (scope.noDataDistricts.indexOf(districtKey) === -1) {
                  scope.noDataDistricts.push(districtKey);
                }
              });
            }

            /**
             * filter out none-data-years
             */
            if (!filteredYears.length) {
              scope.disabledDataLayers = [];
            }

            /**
             * calls lineChartFunction
             */
            lineChartFunction
              .height(height)
              .indicator(scope.selectedIndicatorSet)
              .focusDistrict(scope.mouseOverFeature)
              .redLines(redLines)
              .decimals(decimals)
              .maxAxisValue(maxAxisValue)
              .years(data.yearsWithData);

            d3.select(element.find('.widget-inner:first')[0])
              .data([data.data])
              .call(lineChartFunction);
          } else {
            removeChart();
          }
        } else {
          removeChart();
        }
      };

      /**
       * defines watcher
       */
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var layersWatcher = scope.$watch('layers', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var indicatorToShowWatcher = scope.$watch('config.indicatorToShow', rerender);
      var disabledDistrictsWatcher = scope.$watchCollection('config.disabledDistricts', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var layerWatcher = scope.$watch('layer', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var disabledDataLayersWatcher = scope.$watchCollection('disabledDataLayers', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var disabledListIndexWatcher = scope.$watchCollection('disabledListIndex', rerender);
      var selectedDistrictKeyWatcher = scope.$watch('selectedDistrictKey', rerender);

      /**
       * removes watcher on destroy
       */
      element.on('$destroy', function () {
        layersWatcher();
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        indicatorToShowWatcher();
        disabledDistrictsWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        disabledListIndexWatcher();
        disabledDataLayersWatcher();
        selectedDistrictKeyWatcher();

        /** removes tooltip dom element */
        if (angular.isDefined(lineChartFunction.tip())) {
          lineChartFunction.tip().destroy();
        }
      });
    }
  };
});
